export default class Util {
    static isInView($element) {
        const docTop = jQuery(window).scrollTop();
        const docBottom = docTop + jQuery(window).height();
        const elTop = $element.offset().top;
        const elBottom = elTop + $element.height();
        return (elTop <= docBottom) && (elBottom >= docTop);
    }
}
